import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { ROUTE_TITLES } from "./paths";

/** What the tab says, so a browser with six of them open is readable. */
const DocumentTitle = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const match = Object.keys(ROUTE_TITLES).find((path) =>
      pathname.startsWith(path)
    );

    document.title = match
      ? `${ROUTE_TITLES[match]} · Naurist Admin`
      : "Naurist Admin";
  }, [pathname]);

  return null;
};

export default DocumentTitle;
